import { createContext } from 'react';
import { isEmpty } from 'lodash';
import objectScan from 'object-scan';

// Consider as an enquiry option if (no resource_id and option_groups is empty) or (type is `enquiry-option`).
export const isEnquiryOption = (option) =>
  (!option.resource_id && isEmpty(option.option_groups)) ||
  option.type === 'enquiry-option';

export const openEnquiry = (subTitle, qtConfigOptionTitle) => {
  const $enquiryCanvas = document.querySelector(
    '#experience-enquiry-form-off-canvas'
  );
  const enquiryCanvas = new window.Offcanvas($enquiryCanvas);
  const $subTitle = document.querySelector('#enquiry-form__sub-title');
  const $qtConfigOptionTitle = document.querySelector(
    'input[name="fields[qtConfigOptionTitle]"]'
  );

  $subTitle.innerHTML = subTitle;
  $qtConfigOptionTitle.value = qtConfigOptionTitle;
  enquiryCanvas.show();

  // Reset sub-title when closing the enquiry canvas
  const event = 'hidden.bs.offcanvas';
  const listener = () => {
    $subTitle.innerHTML = '';
    $qtConfigOptionTitle.value = '';

    // Only run this listener once
    $enquiryCanvas.removeEventListener(event, listener);
  };

  $enquiryCanvas.addEventListener(event, listener);
};

export const ExperienceContext = createContext();

export const searchForBookable = (optionGroups) =>
  objectScan(['**'], {
    rtn: 'value',
    filterFn: ({ value }) => value?.resource_id !== undefined,
  })(optionGroups);

export const isSingleBookingOption = (optionGroups) =>
  searchForBookable(optionGroups).length === 1 &&
  objectScan(['**'], {
    rtn: 'value',
    filterFn: ({ value }) => value?.type === 'enquiry-option',
  })(optionGroups).length === 0;
